<template>
  <Modal title="上传凭证" v-model="editModal" width="800">
    <Form ref="form" class="form" :label-width="80" label-position="left"
          :model="fundPackageData" :rules="fromRules"  >
      <Row>
        <i-col :span="6">
          <FormItem label="学生ID" prop="uid">
            <Input readonly v-model.number="fundPackageData.uid"></Input>
          </FormItem>
        </i-col>
        <i-col :span="6" :offset="1">
          <Form-item label="学生姓名" prop="nickname">
            <Input readonly v-model="fundPackageData.nickname"></Input>
          </Form-item>
        </i-col>
<!--        <i-col :span="10" :offset="1">-->
<!--          <Form-item label="课程套餐" prop="desc">-->
<!--            <Input readonly v-model="fundPackageData.desc"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
      </Row>
      <Row>
        <i-col :span="6">
          <Form-item label="课时赠送" prop="discountNum">
            <Input readonly v-model.number="fundPackageData.discountNum"></Input>
          </Form-item>
        </i-col>
        <i-col :span="6" :offset="1">
          <Form-item label="现金减免" prop="discount">
            <Input readonly v-model="fundPackageData.discount"></Input>
          </Form-item>
        </i-col>
<!--        <i-col :span="6" :offset="1">-->
<!--          <Form-item label="请假次数" prop="leaveNum">-->
<!--            <Input readonly v-model="fundPackageData.leaveNum"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
      </Row>
      <Row>
        <i-col :span="6">
          <Form-item label="订单原价" prop="amount">
            <Input readonly v-model="fundPackageData.amount"></Input>
          </Form-item>
        </i-col>
        <i-col :span="6" :offset="1">
          <Form-item label="实付金额" prop="payAmount">
            <Input readonly v-model="fundPackageData.payAmount"></Input>
          </Form-item>
        </i-col>
      </Row>
      <!--<Row>
        <i-col :span="21">
          <Form-item label="内容" prop="content">
                     &lt;!&ndash;v-for="(item, index) in formDynamic.items"&ndash;&gt;
                     &lt;!&ndash;v-if="item.status"&ndash;&gt;
                     &lt;!&ndash;:key="index"&ndash;&gt;
                     &lt;!&ndash;:label="'Item ' + item.index"&ndash;&gt;
                     &lt;!&ndash;:prop="'items.' + index + '.value'">&ndash;&gt;
            <span>购买原因:</span>
            <div>  </div>
            <span>老师专业&nbsp;&nbsp;</span>
            <Checkbox v-model="fundPackageData.isTeacherGood" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;服务贴心&nbsp;&nbsp;</span>
            <Checkbox v-model="fundPackageData.isServiceGood" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;性价比高&nbsp;&nbsp;</span>
            <Checkbox v-model="fundPackageData.isPriceGood" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            <span>&nbsp;&nbsp;喜欢固定模式&nbsp;&nbsp;</span>
            <Checkbox v-model="fundPackageData.likeFixedMode" true-value="1" false-value="0" @on-change="onChange">YES</Checkbox>
            &lt;!&ndash;<Button type="dashed" long @click="handleAdd" icon="plus-round">添加标签</Button>&ndash;&gt;
            &lt;!&ndash;<Button type="primary" @click="">添加标签</Button>&ndash;&gt;
            <Input type="textarea" v-model="fundPackageData.specialRemark" placeholder="其他/备注" @on-change="onChange"></Input>
          </Form-item>
        </i-col>
      </Row>-->
<!--      <Row>-->
<!--        <i-col :span="6" :offset="1">-->
<!--          <Form-item label="支付状态" prop="operateStatus">-->
<!--            <Select v-model="fundPackageData.state" @on-change="allThePay" transfer>-->
<!--&lt;!&ndash;              <Option :value="4">部分支付</Option>&ndash;&gt;-->
<!--              <Option :value="5">全部支付</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="5" :offset="1">-->
<!--          <Form-item label="本次支付:" prop="firstPay" :label-width="70">-->
<!--            <Input v-model.number="fundPackageData.hasPayAmount" placeholder="不得少于1000" @on-change="calculate" :disabled="lastPayAmount < 0 || lastPayAmount === 0"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="5" :offset="1">-->
<!--          <Form-item label="剩余尾款:" prop="firstPay" :label-width="70">-->
<!--            <Input v-model.number="lastPayAmount" disabled></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--      </Row>-->
      <Row>
        <i-col :span="9">
          <Form-item label="支付方式" prop="payWay">
            <Select v-model.number="fundPackageData.payWay" transfer>
              <Option  v-for="item in payWayList"
                       :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="9" style="margin-left: 20px;">
          <Form-item label="支付时间" prop="payTime">
            <el-date-picker
              v-model.number="payTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="timestamp"
              :picker-options="payTimePickerOptions"
              @change="changPayTime"
            >
            </el-date-picker>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :span="11" :offset="1" v-if="showDealMonth">
          <Form-item label="成交月份" prop="dealMonth">
            <Select v-model="fundPackageData.dealMonth" placeholder="请选择成交月份" transfer>
              <Option v-for="item in dealMonthOptions"
                      :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :span="15">
          <Form-item label="上传凭证" prop="url">
            <!--<image-upload :defaultFileList="defaultPicList" v-model="fundPackageData.url"/>-->
            <multiple-image-upload :num="200" :defaultFileList="defaultPicList" v-model="fundPackageData.url" on-file-change="onFileChange"/>
            <!--<multi-upload :defaultFileList="defaultPicList" v-model="fundPackageData.url"></multi-upload>-->
            <!--<span>分笔付款再次上传凭证时，需要把历史凭证一起上传！</span>-->
          </Form-item>
        </i-col>
      </Row>
      <!--<Row>
        <i-col :span="8" >
          <Form-item label="下次联系日期" prop="nextHandlerTime">
            <Date-picker type="date" format="yyyy-MM-dd" @on-change="nextTimeDateChange"
                         :value="fundPackageData.nextHandlerTime" placement="top-start"></Date-picker>
          </Form-item>
        </i-col>
        <i-col :span="8" :offset="1">
          <Form-item label="下次联系人" prop="nextHandlerId">
            <Select v-model.number="fundPackageData.nextHandlerId" filterable transfer>
              <Option v-for="item in nextHandler"
                      :value="item.id" :key="item.id">{{ item.nickname }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="6" :offset="1">
          <Form-item label="状态" prop="operateStatus">
            <Select v-model="fundPackageData.operateStatus" transfer>
              <Option value="0">未处理</Option>
              <Option value="1">已处理</Option>
            </Select>
          </Form-item>
        </i-col>
      </Row>-->
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">取消</Button>
      <Button type="primary" size="large" :loading="loading" @click="handleSubmit()">保存</Button>
    </div>
  </Modal>
</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    name: 'AddVoucherModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        loading: false,
        subNum: 0,
        nextHandler: [],
        payWayList: this.$constant.payWayNew,
        defaultPicList: [],
        lastPayAmount: 0,
        payTime: null,
        payTimePickerOptions: {
          disabledDate (time) {
            return time.getTime() > Date.now()
          }
        },
        showDealMonth: false,
        dealMonthOptions: [
          {
            value: 1,
            label: '上月'
          },
          {
            value: 0,
            label: '本月'
          }
        ],
        fundPackageData: {
          id: '',
          uid: null,
          nickname: '',
          num: null,
          amount: null,
          discount: null,
          discountNum: null,
          payAmount: null,
          leaveNum: null,
          desc: null,
          content: '',
          nextHandlerTime: dates.today(),
          nextHandlerId: null,
          operateStatus: '0',
          payWay: null,
          payTime: null,
          isTeacherGood: null,
          isServiceGood: null,
          isPriceGood: null,
          likeFixedMode: null,
          specialRemark: null,
          url: '',
          state: 4,
          hasPayAmount: 0,
          dealMonth: null
        },
        formData: {
          uid: null,
          content: '',
          nextHandlerTime: dates.today(),
          nextHandlerId: null,
          operateStatus: '0',
          payWay: null,
          payTime: null,
          isTeacherGood: null,
          isServiceGood: null,
          isPriceGood: null,
          likeFixedMode: null,
          specialRemark: null,
          url: null
        },
        fromRules: {
          uid: [
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
            { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' },
          ],
          payWay: [
            { type: 'number', required: true, message: '付款方式不能为空', trigger: 'blur' }
          ],
          payTime: [
            { type: 'number', required: true, message: '支付时间不能为空', trigger: 'blur' }
          ],
          url: [
            { type: 'string', required: true, message: '凭证图片不能为空', trigger: 'blur' }
          ],
          /*
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }
          ]
          */
//          nextHandlerId: [
//            { type: 'number', required: true, message: '请选择下次联系人', trigger: 'blur' },
//          ]
        },
      }
    },
    created () {
    },
    mounted () {
      let self = this
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })

//      this.getUserInfo()
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      onFileChange (fileList) {
        this.defaultPicList = fileList
      },
      changPayTime () {
        if (this.payTime && this.payTime > Date.now()) {
          this.$Message.warning('支付时间不能晚于当前时间')
          this.payTime = null
          this.fundPackageData.payTime = null
          this.formData.payTime = null
          return
        }
        this.fundPackageData.payTime = this.payTime
        this.formData.payTime = this.payTime / 1000
      },
      nextTimeDateChange (value) {
        this.fundPackageData.nextHandlerTime = value
      },
      calculate () {
        this.lastPayAmount = this.fundPackageData.payAmount - this.data.hasPayAmount
        this.lastPayAmount = this.lastPayAmount - this.fundPackageData.hasPayAmount
      },
      allThePay () {
        if (this.fundPackageData.state === 5) {
          this.fundPackageData.hasPayAmount = this.lastPayAmount
          this.lastPayAmount = 0
        }
      },
      handleSubmit () {
        let self = this
        if (self.subNum === 0) {
          this.$refs.form.validate((valid) => {
            if (!valid) {
              self.$Message.warning('信息输入错误!')
              self.loading = false
              return
            }
            if (self.payTime && self.payTime > Date.now()) {
              self.$Message.warning('支付时间不能晚于当前时间')
              self.loading = false
              return
            }
            self.subNum ++
            self.loading = true
            self.formData = self.fundPackageData
            self.formData.fundPackageId = self.fundPackageData.id
            self.formData.payTime = self.payTime / 1000
            self.$http.post('/userTrack/buySuccess', self.formData).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('提交成功!')
                self.successCallback()
                self.onClose()
                self.onSuccess()
              }
              if (res && res.status === '505') {
                self.fundPackageData.dealMonth = 1
                self.showDealMonth = true
                // 添加 dealMonth 的必填验证规则
                self.fromRules = {
                  ...self.fromRules,
                  dealMonth: [
                    {type: 'number', required: true, message: '成交月份不能为空', trigger: 'blur'}
                  ]
                }
                self.$Message.warning('请选择成交月份')
              }
              self.subNum = 0
              self.loading = false
            })
          })
        }
      },
      onChange () {
        var arr = []
        if (this.fundPackageData.isTeacherGood === '1') {
          arr.push('老师专业')
          arr.push('、')
        }
        if (this.fundPackageData.isServiceGood === '1') {
          arr.push('服务贴心')
          arr.push('、')
        }
        if (this.fundPackageData.isPriceGood === '1') {
          arr.push('性价比高')
          arr.push('、')
        }
        if (this.fundPackageData.likeFixedMode === '1') {
          arr.push('喜欢固定模式')
          arr.push('、')
        }
//        去掉最后一个“、”
        arr.splice(-1, 1, ' ')

        if (this.fundPackageData.specialRemark) {
          arr.push('备注：')
          arr.push(this.fundPackageData.specialRemark)
        }

        this.fundPackageData.content = arr.join('')
        console.log(this.fundPackageData.content)
      },
      onClose () {
        this.$emit('on-close')
        this.payTime = null
        this.resetDealMonthField()
        this.successCallback()
      },
      onSuccess () {
        this.$emit('on-success')
      },
      resetDealMonthField () {
        this.showDealMonth = false
        this.fundPackageData.dealMonth = null
        // 清空验证规则
        delete this.fromRules.dealMonth
      }
    },
    watch: {
      value (val) {
        this.$refs['form'].resetFields()
        this.defaultPicList = []
        this.fundPackageData = {}
        this.resetDealMonthField()
        if (val && this.data) {
          this.$helper.mergeProperties(this.data, this.fundPackageData)
          this.payTime = this.fundPackageData.payTime
          let pics = this.data.urls
          if (pics) {
            for (let i in pics) {
              let url = pics[i] + ''
              let name = pics[i] + ''
              for (let i = 0; i < 3; i++) {
                name = name.substring(name.indexOf('/') + 1)
              }
              this.defaultPicList.push({name: name, url: url})
            }
          }
        } else {
          this.defaultPicList = []
        }
        if (val) {
          this.fundPackageData.state = 4
          this.fundPackageData.hasPayAmount = 0
          this.lastPayAmount = this.fundPackageData.payAmount - this.data.hasPayAmount
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddVoucherModal.vue?d9ab724a